// ProfileModal.jsx
import React from 'react';
import { X } from 'lucide-react';

const ProfileModal = ({ isOpen, onClose, children, colors = {} }) => {
  if (!isOpen) return null;

  const defaultColors = {
    bg: '#ffffff',
    border: '#e5e7eb',
    shadow: 'rgba(0, 0, 0, 0.1)',
    primary: '#3b82f6',
  };

  const themeColors = { ...defaultColors, ...colors };

  return (
    <div 
      className="fixed inset-0 z-50 overflow-y-auto flex items-center justify-center px-4 py-8 sm:px-6 lg:px-8"
      style={{ 
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
      }}
      onClick={onClose}
    >
      <div 
        className="relative w-full max-w-2xl rounded-2xl shadow-2xl transform transition-all duration-300 ease-in-out"
        style={{
          backgroundColor: themeColors.bg,
          border: `1px solid ${themeColors.border}`,
          maxHeight: '90vh',
          overflowY: 'auto',
          margin: 'auto'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button 
          onClick={onClose} 
          className="absolute top-4 right-4 p-2 rounded-lg transition-all hover:scale-110 z-10"
          style={{
            backgroundColor: `${themeColors.primary}15`,
            color: themeColors.primary,
          }}
        >
          <X size={20} />
        </button>

        {/* Content */}
        <div className="p-6 sm:p-8 pt-16">
          {children}
        </div>
      </div>
    </div>
  );
};

export default ProfileModal;